module.exports = __webpack_public_path__ + "img/nav_icon_vip.9a6594c8.svg";